import React, { useContext, useState } from 'react';
import { baseUrl } from '../utils/constants';

const initialState = {
  currentEmployer: {},
  employerRefId: -1
};

const initialEmployer = {
  employerRefId: -1,
  name: '',
  registrationNumber: '',
  externalIdentificationNumber: '',
  forceDeductionOverrides: false,
  isStaff: false,
  payrollPaypointlDeductionsEnabled: false,
  paypointRefId: 1,
  mainContactPerson: '',
  mainContactMail: '',
  mainContactNumber: '',
  monthlySalaryEnabled: false,
  monthlySalaryDateType: 0,
  monthlySalaryDateDay: 0,
  salaryDateDay: null,
  salaryDateType: null,
  weekDay: 0,
  employerType: 0,
  employerState: 0,
  enforceSingleProduct: false,
  affordabilityOverride: false,
  affordabilityReoccuringIncomePercent: 0,
  affordabilityAdHocIncomePercent: 0,
  affordabilityVariableIncomePercent: 0,
  affordabilityExposure: 0,
  affordabilityNumerator: 0,
  isValidated: false,
  trustLevel: 1,
  enableEntryTrust: false,
  settlementValidDays: 0,
  forceEmployerApproval: false,
  providerLegalDescription: ''
};

export const EmployerContext = React.createContext();

export const EmployerProvider = ({ children }) => {
  const [employerRefId, setEmployerRefId] = useState(-1);
  const [currentEmployer, setCurrentEmployer] = useState(initialEmployer);
  const [employerList, setEmployerList] = useState(initialEmployer);

  const refreshEmployerValues = (employerId) => {
    if (employerId > 0) {
      getEmployerView(employerId);
    } else {
      setEmployerRefId(-1);
      setCurrentEmployer(initialEmployer);
      console.log('just cleared all employers');
    }
  };

  const populateEmployerList = async () => {
    fetch(`${baseUrl}/api/setting/getallemployerslist`)
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned employer list', res);
          console.log('returned employer list. employers', res.employers);
          setEmployerList(res.employers);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const getEmployerView = async (employerId) => {
    fetch(`${baseUrl}/api/setting/GetEmployer?employerRefId=${employerId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned individual employer', result);
          setCurrentEmployer(result.employer);
          setEmployerRefId(result.employer.refId);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  return (
    <EmployerContext.Provider
      value={{
        employerRefId,
        setEmployerRefId,
        currentEmployer,
        setCurrentEmployer,
        refreshEmployerValues,
        getEmployerView,
        employerList,
        populateEmployerList
      }}
    >
      {children}
    </EmployerContext.Provider>
  );
};

export const useEmployerContext = () => useContext(EmployerContext);
